<template>
  <v-card tile class="card-shadow">
    <div class="ma-0 pt-4 pb-2 d-flex align-center justify-start">
      <v-img class="ma-0 pa-0" height="150" contain :src="current_applicant.photo.url" />
    </div>
    <v-list dense disabled>
      <div class="primary">
        <label class="ml-6 subtitle-1 font-weight-medium text-capitalize white--text">
          {{ current_applicant.name }}
        </label>
      </div>

      <v-list-item-group v-model="item" color="primary">
        <!-- <v-list-item-title class="ml-2">{{current_applicant.name}}</v-list-item-title> -->
        <v-list-item v-for="(item, i) in current_applicant.info" :key="i">
          <v-list-item-icon class="mr-1">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title
              class="ml-0 mr-0 d-flex body-2 justify-space-between"
            >
              <div>{{ item.title }}</div>
              <div>{{ item.value }}</div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'ApplicantInfo',
  props: {
    current_applicant: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>

.card-shadow {
  box-shadow: 0px 0px 75px #00000024 !important;
}
</style>
